import { Autocomplete, Dialog, DialogContent, DialogTitle, FormHelperText, TextField, Tooltip } from "@mui/material"
import ButtonComponent from "../shared/button/button.component"
import Grid from "@mui/material/Grid";
import { CancelIcon } from "../../icon";
import { useEffect, useState } from "react";
import { mapToPhoneNumber, PhoneNumbergroup, PhoneNumberModel } from "../../models/phone-number.model";
import { validateForm } from "../shared/form-validation";
import { UserService } from "../../services/UserService";
import { NewOrganization, OrganizationModel } from "../../models/organization.model";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { UtilityService } from "../../services/UtilityService";
import { PhoneNumberGroupService } from "../../services/PhoneNumberGroupsServices";
import { buttonLabels, ToasterTexts } from "../shared/constants";
import { LoadPhoneNumberGroups, LoadUsers } from "../../actions";
import { useDispatch } from "react-redux";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { updateOrganizationsphoneNumbers } from "../../reducers/reducer";
import { Role } from "../../models/roles.model";
import { UserModel } from "../../models/users.model";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";

interface IProps {
    group?: PhoneNumbergroup;
    handleclose: (isconfirm: boolean) => void;
    show: boolean;
}
const PhoneGroupView = (props: IProps) => {

    const dispatch = useDispatch()

    const Organizations: OrganizationModel[] = useSelector(selector.organizations);
    const PhoneNumberGroups: PhoneNumbergroup[] = useSelector(selector.phonenumbergroups);
    const OrganizationPhoneNumberGroups = useSelector(selector.OrganzationPhoneNumberGroups);
    const NewOrganizations: NewOrganization[] = useSelector(selector.newOrganizations)


    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const organizationId = UserService.getCurrentUserOrgId();
    const organizationPhonenumbers: PhoneNumberModel[] = useSelector(selector.OrganizationsphoneNumbers);
    const Users: UserModel[] = useSelector(selector.users)

    const [groupData, setGroupData] = useState<PhoneNumbergroup>();
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [errors, setErrors] = useState<{
        Name: string,
        OrganizationID: String,
        Description: string,
        phonenumbers: string,
    }>({
        Name: "",
        OrganizationID: "",
        Description: "",
        phonenumbers: "",
    })

    useEffect(() => {
        LoadUsers(dispatch)
        setGroupData(props.group)
    }, [props.group])

    useEffect(() => {
        if (props.group) {
            setGroupData(props.group);
            if (UserService.hasSysAdminRole() && props.group.OrganizationID) {
                PhoneNumberService.getGridByOrganizations([props.group.OrganizationID])
                    .then((res) => {
                        dispatch(updateOrganizationsphoneNumbers(res.data.map(mapToPhoneNumber)));
                    })
                    .catch((err) => {
                    });
            }
        }
    }, [props.group]);

    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => { setErrors({ ...errors, ...Errors }) })
        setGroupData({ ...groupData, GroupName: value });
    };

    const handleOrgChnage = (orgId: string) => {
        if (orgId) {
            setErrors({ ...errors, OrganizationID: "" });
            setGroupData({ ...groupData, OrganizationID: orgId })
        }
        else {
            setGroupData({ ...groupData, OrganizationID: "" })
            setErrors({ ...errors, OrganizationID: "Organization cannot be blank" })
        }
        if (orgId) {
            PhoneNumberService.getGridByOrganizations([orgId]).then((res) => {
                if (res.status === 200) {
                    dispatch(updateOrganizationsphoneNumbers(res.data.map(mapToPhoneNumber)))
                }
            }).catch((err) => {
            })
        }
    };

    const handledescription = (event: any) => {
        setGroupData({ ...groupData, Description: event.target.value })
        setErrors({ ...errors, Description: "" })
        if (event.target.value === "") setErrors({ ...errors, Description: "Description cannot be blank" })
    }

    const createPhoneNumberGroup = (isEdit: boolean) => {
        const resolvedOrgId = UserService.hasSysAdminRole()
            ? (groupData?.OrganizationID || "")
            : (organizationId || "");

        const validationObj = {
            Name: groupData?.GroupName ?? "",
            OrganizationID: resolvedOrgId,
            Description: groupData?.Description ?? "",
        };

        if (!validateForm(validationObj, (Errors) => setErrors((prev) => ({ ...prev, ...Errors })))) {
            return;
        }

        let data = { ...groupData, OrganizationID: groupData?.OrganizationID ? groupData?.OrganizationID : organizationId }
        setIsLoading(true)

        if (isEdit) {
            PhoneNumberGroupService.updatePhoneNumberGroup(data).then((res) => {
                props.handleclose(true);
                setIsLoading(false);
                setToast(ToasterTexts.PHONENUMBER_GROUP_EDIT_SUCCESS.replace('<Name>', data.GroupName), ToasterType.SUCCESS)
                // if (UserService.hasOrgAdminRole()) LoadPhoneNumberGroups(dispatch, data.OrganizationID);
            }
            ).catch((err) => {
                props.handleclose(true);
                setIsLoading(false);
            })

        } else {
            PhoneNumberGroupService.createPhoneNumberGroup(data).then((res) => {
                props.handleclose(true);
                setIsLoading(false);
                if (UserService.hasOrgAdminRole()) LoadPhoneNumberGroups(dispatch, data.OrganizationID);
                setToast(ToasterTexts.PHONENUMBER_GROUP_ADD_SUCCESS.replace('<Name>', data.GroupName), ToasterType.SUCCESS)
            }
            ).catch((err) => {
                props.handleclose(true)
                setIsLoading(false);
            })
        }

    }

    const handlePhoneNumbersChange = (Value: PhoneNumberModel[] | null) => {
        const removed = groupData?.PhoneNumbers?.filter((p: any) => !Value?.some(np => np.PhoneNumber === p.phoneNumber));
        const hasMangers = removed?.some(removedPhone => Users.some(x => x.RoleID === Role.MANAGER && x.PhoneNumberID === removedPhone.phoneNumberId));

        if (hasMangers) {
            setErrors({ ...errors, phonenumbers: "Cannot remove this phone number because a Manager is using it" })
        } else { setErrors({ ...errors, phonenumbers: "" }) }
        // }

        setGroupData({
            ...groupData, PhoneNumbers: Value.map(x => ({
                phoneNumberId: x.ID,
                phoneNumber: x.PhoneNumber,
                phoneNumberName: x.Name,
            })),
        });
    }

    const PhoneNumbersInGroups = UserService.hasSysAdminRole() ?
        OrganizationPhoneNumberGroups.filter(x => x.Id !== groupData?.Id).flatMap(group => group.PhoneNumbers || []).map(y => y.phoneNumber)
        : PhoneNumberGroups.filter(x => x.Id !== groupData?.Id).flatMap(group => group.PhoneNumbers || []).map(y => y.phoneNumber);

    const availablePhoneNumbers = UserService.hasSysAdminRole() ? organizationPhonenumbers.filter(pn => !PhoneNumbersInGroups.includes(pn.PhoneNumber)) : PhoneNumbers.filter(pn => !PhoneNumbersInGroups.includes(pn.PhoneNumber));

    return (<>
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={props.show}
            // onClose={props.handleclose}
            classes={{ paper: "w-66 br-2 dialogue-shadow" }}
            disableEscapeKeyDown
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex'>
                    <span className={"h2-regular color-display-title"}>{groupData?.Id ? "Edit Line Group" : "Create Line Group"}</span>
                    <Tooltip title='Close' placement='bottom-start'>
                        <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.handleclose(false)} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent className=" p-2 o-x-hidden">
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} >
                        <TextField autoFocus
                            name="Name"
                            placeholder="Name"
                            label="Name"
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                            value={groupData?.GroupName}
                            onChange={(e) => handleChange(e.target.name, e.target.value)
                            }
                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                            autoComplete='no'
                        />
                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                            {errors?.Name}
                        </FormHelperText>
                    </Grid>
                    {UserService.hasSysAdminRole() &&
                        <Grid item xs={12} >
                            <Autocomplete
                                size="small"
                                className={"bg-color-secondary c-pointer"}
                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={[...Organizations, ...NewOrganizations].filter(x => (x.Name !== null && x.Name !== "Admin" && !x.IsDeleted))}
                                value={!!groupData?.OrganizationID ? ([...Organizations, ...NewOrganizations].find((x) => x.ID === groupData?.OrganizationID || null)) : null}
                                getOptionLabel={(option: any) => option?.Name}
                                onChange={(e: any, value: any) => handleOrgChnage(value?.ID || "")}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} >
                                        <span className={'c-poinet h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90'}>
                                            {option.Name}
                                        </span>
                                    </li>
                                )}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        variant="outlined"
                                        label="Organization *"
                                        name="OrganizationID"
                                    />}
                            />
                            {
                                errors?.OrganizationID &&
                                <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                                    {errors?.OrganizationID}
                                </FormHelperText>
                            }
                        </Grid>}

                    <Grid item xs={12} className="mt-1">
                        {
                            <Autocomplete
                                multiple
                                size="small"
                                limitTags={1}
                                className={"c-pointer"}
                                options={availablePhoneNumbers}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        label="Select Phone Numbers"
                                        name="PhoneNumber"
                                        variant="outlined"
                                    />}
                                // disableCloseOnSelect={true}
                                getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.Name})`}
                                value={availablePhoneNumbers.filter(option => groupData?.PhoneNumbers?.some(x => x.phoneNumber === option.PhoneNumber))}
                                onChange={(event, value) => handlePhoneNumbersChange(value)
                                    // if (value) {
                                    //     setGroupData({ ...groupData, PhoneNumbers: value.map(x => ({ phoneNumberId: x.ID, phoneNumber: x.PhoneNumber, phoneNumberName: x.Name })) });
                                    // } else {
                                    //     setGroupData({ ...groupData, PhoneNumbers: [{ phoneNumberId: "", phoneNumber: "", phoneNumberName: "" }] });
                                    // }
                                }
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops}>
                                        <span className={"c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-92"}>
                                            <div >{option?.Name} </div>
                                            <div> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                        </span>
                                    </li>
                                )}
                                disabled={UserService.hasManagerRole()}
                            />
                        }
                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                            {errors?.phonenumbers}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} >
                        <TextField
                            name="Description"
                            placeholder="Description"
                            label="Description"
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                            value={groupData?.Description}
                            onChange={handledescription}
                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                            autoComplete='no'
                        />
                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                            {errors?.Description}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} >
                        <TextField
                            name="Queries"
                            placeholder="Queries"
                            label="Queries"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={groupData?.Queries}
                            onChange={(e) => { setGroupData({ ...groupData, Queries: e.target.value }) }
                            }
                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                            autoComplete='no'
                        />
                    </Grid>
                </Grid>
                <div className="d-flex float-right mt-3 mb-2">
                    <ButtonComponent OnClick={() => createPhoneNumberGroup(!!props.group)} Loading={isLoading} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={Object.values(errors).some(x => x !== "") ? "disabled-btn-small" : "primary-btn-small"} />
                    <ButtonComponent OnClick={() => props.handleclose(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={""} Variant={"secondary-btn-small"} />
                </div>
            </DialogContent>
        </Dialog>
    </>)
}
export default PhoneGroupView;
